







import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ConfigurationItem from "@/components/ConfigurationItem.vue";
import { IItemParams } from "@/models/itemParams";

@Component({
  components: {
    ConfigurationItem
  }
})
export default class ConfigurationItemGroup extends Vue {
  @Prop({type: Array, required: true}) params!: IItemParams[];

  private onItemSelected(params: IItemParams) {
    this.params.forEach(x => x.isSelected = false);
    params.isSelected = true;
  }
}
